// Basic email shape check -- good enough to keep obvious typos out of a
// recipient list. Mirrors parseEmailList in pi_ecommerce_api
// (src/services/email/recipients.ts) so stored values round-trip cleanly.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) => EMAIL_RE.test(String(value).trim());

/**
 * Split a free-text recipient list (comma / semicolon / newline separated)
 * into { valid, invalid } arrays -- trimmed, blank-dropped, and
 * case-insensitively deduped.
 */
export const splitEmailList = (raw) => {
	const seen = new Set();
	const valid = [];
	const invalid = [];
	String(raw || '')
		.split(/[,;\n]/)
		.map((entry) => entry.trim())
		.filter(Boolean)
		.forEach((entry) => {
			const key = entry.toLowerCase();
			if (seen.has(key)) return;
			seen.add(key);
			(isValidEmail(entry) ? valid : invalid).push(entry);
		});
	return { valid, invalid };
};
